import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./FoodInfo.css";

/* Slide order matches foodinfo.php exactly */
const SLIDES = [
  { bg: "#ADBCF0", img: "https://appcdn.goqii.com/storeimg/76925_1718715608.png" },
  { bg: "#FFB391", img: "https://appcdn.goqii.com/storeimg/43027_1686647812.png" },
  { bg: "#CEE4F2", img: "https://appcdn.goqii.com/storeimg/96302_1686734558.png" },
  { bg: "#F7DAA3", img: "https://appcdn.goqii.com/storeimg/62527_1685701739.png" },
  { bg: "#DBEDB8", img: "https://appcdn.goqii.com/storeimg/81072_1686649152.png" },
];

const CTA_URL = "https://goqii.com/app?fsn=24&fssn=0";

export default function FoodInfo() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const params = new URLSearchParams(window.location.search);
  const withCoach =
    params.get("withcoach") === "1" || params.get("withcoach") === "Y";
  const foodEnable =
    params.get("foodEnable") === "1" || params.get("foodEnable") === "Y";

  const isFirst = activeIndex === 0;
  const isLast = activeIndex === SLIDES.length - 1;
  const ctaLabel = foodEnable
    ? t("foodInfo.btnLogFood")
    : t("foodInfo.btnTryNutri");

  /* Tap left half → prev, right half → next (matches PHP JS) */
  const handleSlideTap = (e) => {
    if (!swiperRef.current) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const tapX = e.clientX - rect.left;
    if (tapX > rect.width / 2) {
      swiperRef.current.slideNext();
    } else {
      swiperRef.current.slidePrev();
    }
  };

  return (
    <main className="fi-main">
      <div className="fi-wrap">
        <Swiper
          className="fi-swiper"
          modules={[Pagination]}
          speed={400}
          loop={false}
          pagination={{ clickable: true }}
          onSwiper={(s) => { swiperRef.current = s; }}
          onSlideChange={(s) => setActiveIndex(s.activeIndex)}
        >
          {/* ── Slide 1 ── */}
          <SwiperSlide>
            <section
              className="fi-slide"
              style={{ backgroundColor: SLIDES[0].bg }}
              onClick={handleSlideTap}
            >
              <img src={SLIDES[0].img} alt="" className="fi-img" />
              <div className="fi-content">
                <h1 className="fi-title">
                  <span className="fi-brand">NutriGenius</span>
                  <br />
                  {t("foodInfo.slide1TitleSub")}
                </h1>
                <h2 className="fi-subtitle">
                  {withCoach
                    ? t("foodInfo.slide1SubCoach")
                    : t("foodInfo.slide1SubNoCoach")}
                </h2>
              </div>
            </section>
          </SwiperSlide>

          {/* ── Slide 2 ── */}
          <SwiperSlide>
            <section
              className="fi-slide"
              style={{ backgroundColor: SLIDES[1].bg }}
              onClick={handleSlideTap}
            >
              <img src={SLIDES[1].img} alt="" className="fi-img" />
              <div className="fi-content">
                <h1 className="fi-title">{t("foodInfo.slide2Title")}</h1>
                <h2 className="fi-subtitle">{t("foodInfo.slide2Sub")}</h2>
              </div>
            </section>
          </SwiperSlide>

          {/* ── Slide 3 ── */}
          <SwiperSlide>
            <section
              className="fi-slide"
              style={{ backgroundColor: SLIDES[2].bg }}
              onClick={handleSlideTap}
            >
              <img src={SLIDES[2].img} alt="" className="fi-img" />
              <div className="fi-content">
                <h1 className="fi-title">{t("foodInfo.slide3Title")}</h1>
                {/* slide3Sub contains <b> tag */}
                <h2
                  className="fi-subtitle"
                  dangerouslySetInnerHTML={{ __html: t("foodInfo.slide3Sub") }}
                />
              </div>
            </section>
          </SwiperSlide>

          {/* ── Slide 4 ── */}
          <SwiperSlide>
            <section
              className="fi-slide"
              style={{ backgroundColor: SLIDES[3].bg }}
              onClick={handleSlideTap}
            >
              <img src={SLIDES[3].img} alt="" className="fi-img" />
              <div className="fi-content">
                <h1 className="fi-title">{t("foodInfo.slide4Title")}</h1>
                <h2 className="fi-subtitle">
                  {withCoach
                    ? t("foodInfo.slide4SubCoach")
                    : t("foodInfo.slide4SubNoCoach")}
                </h2>
              </div>
            </section>
          </SwiperSlide>

          {/* ── Slide 5 (CTA) ── */}
          <SwiperSlide>
            <section
              className="fi-slide"
              style={{ backgroundColor: SLIDES[4].bg }}
              onClick={handleSlideTap}
            >
              <img src={SLIDES[4].img} alt="" className="fi-img" />
              <div className="fi-content fi-content--cta">
                <a
                  href={CTA_URL}
                  className="fi-cta-btn"
                  onClick={(e) => e.stopPropagation()}
                >
                  {ctaLabel}
                </a>
                <h1 className="fi-title fi-title--cta">
                  {t("foodInfo.slide5Title")}
                </h1>
              </div>
            </section>
          </SwiperSlide>
        </Swiper>
      </div>

      {/* Fixed Back / Next buttons — outside swiper, state-driven visibility */}
      {!isFirst && (
        <button
          className="fi-nav fi-nav--back"
          onClick={() => swiperRef.current?.slidePrev()}
        >
          {t("foodInfo.btnBack")}
        </button>
      )}
      {!isLast && (
        <button
          className="fi-nav fi-nav--next"
          onClick={() => swiperRef.current?.slideNext()}
        >
          {t("foodInfo.btnNext")}
        </button>
      )}
    </main>
  );
}
